"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convert = void 0;
/**
 * Convert converts a number from a given unit to a number in the target unit if it is possible. Otherwise it returns NaN
 * @param x - The number we wish to convert from `givenUnit` to `targetUnit`
 * @param givenUnit The unit which the number is given in
 * @param targetUnit The target unit which we wish to convert to
 */

function convert(x, givenUnit, targetUnit) {
  var power = {
    "mW": 0.001,
    "W": 1,
    "kW": 1000,
    "MW": 1000 * 1000,
    "GW": 1000 * 1000 * 1000,
    "hp": 745.699872
  };
  var energy = {
    "mWh": 0.001,
    "Wh": 1,
    "kWh": 1000,
    "MWh": 1000 * 1000,
    "GWh": 1000 * 1000 * 1000,
    "hph": 745.699872
  };
  var volume = {
    "ml": 0.001,
    "l": 1,
    "m3": 1000,
    "gal": 3.785411784
  };

  var units = __assign(__assign(__assign({}, power), energy), volume);

  if (units[givenUnit] != null && units[targetUnit] != null) {
    return x * units[givenUnit] / units[targetUnit];
  }

  return NaN;
}

exports.convert = convert;